import i18n from '@/i18n'
import mitmdtlpSelectFromComponent from './components/mitmdtlp-dialog'

const mitmdtlp = {}
mitmdtlp.install = function (Vue) {
  const ToastConstructor = Vue.extend(mitmdtlpSelectFromComponent)
  const instance = new ToastConstructor({ i18n })
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$modalGoodsDetailList = function (
    mitmbaspList,
    multiSelect,
    callback
  ) {
    instance.dialogVisible = true
    instance.multiSelect = multiSelect
    instance.callback = callback

    let itmcdList = this.$baseLodash.map(mitmbaspList, 'itmcd')
    instance.goodslists = mitmbaspList
    instance.queryForm.itmcdList = itmcdList
  }
}
export default mitmdtlp
